import { render } from "./Most.vue?vue&type=template&id=670fa302&scoped=true"
import script from "./Most.vue?vue&type=script&lang=js"
export * from "./Most.vue?vue&type=script&lang=js"

import "./Most.vue?vue&type=style&index=0&id=670fa302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670fa302"]])

export default __exports__